"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const design_system_1 = require("@servicetitan/design-system");
const Styles = __importStar(require("./label.module.css"));
exports.Label = ({ label, tooltip, tooltipDirection = 'r', hasError, error, }) => (react_1.default.createElement("div", { className: classnames_1.default(Styles.label, hasError && Styles.hasError) },
    react_1.default.createElement(design_system_1.Stack, { className: Styles.text },
        react_1.default.createElement(design_system_1.Stack.Item, null, label),
        tooltip && (react_1.default.createElement(design_system_1.Stack.Item, { className: Styles.tooltip },
            react_1.default.createElement(design_system_1.Tooltip, { direction: tooltipDirection, text: tooltip },
                react_1.default.createElement(design_system_1.Icon, { name: "info" }))))),
    hasError && (react_1.default.createElement(design_system_1.Text, { className: Styles.error, size: 1 }, error))));
//# sourceMappingURL=label.js.map